import React, { useCallback, useState } from "react";
import * as styles from "./ReadMoreList.module.scss";
import { Button, ButtonVariant } from "@silversea-ssc/ui-components-react";

interface ReadMoreListProps {
  openLabel: string | JSX.Element;
  className?: string;
  itemsAlwaysVisible?: number;
  buttonVariant: ButtonVariant;
}

const ReadMoreList: React.FC<React.PropsWithChildren<ReadMoreListProps>> = ({
  openLabel,
  className = undefined,
  itemsAlwaysVisible = 2,
  children,
  buttonVariant
}) => {
  const [expanded, setExpanded] = useState(false);
  const close = useCallback(() => setExpanded((e) => !e), []);
  const showMoreButton =
    React.Children.count(children) > itemsAlwaysVisible && !expanded;

  const filteredChildren = React.Children.toArray(children).filter(
    (_child, index) => {
      if (expanded) return true;
      if (index < itemsAlwaysVisible) return true;
      return false;
    }
  );

  return (
    <div className={className}>
      <div className={styles.content}>{filteredChildren}</div>

      {showMoreButton && (
        <Button
          renderAs="button"
          className={styles.button}
          variant={buttonVariant}
          iconName={expanded ? "close" : "plus"}
          onClick={close}
          dataContentPiece={
            expanded ? `read-more-button-close` : `read-more-button-expand`
          }
        >
          {expanded ? null : openLabel}
        </Button>
      )}
    </div>
  );
};

export default ReadMoreList;
